import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "quantityInfo d-flex" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-brand_check" }, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("p", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(_ctx.versandinfo), 1)
    ]));
}
